import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=47c53dd6&scoped=true&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=47c53dd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c53dd6",
  null
  
)

export default component.exports